module.exports = __webpack_public_path__ + "img/edit-2.7db01b6a.svg";